
export function findImageBackgroundRect(group) {
  if (!group) return null;
  return (
    group.findOne('.background') ||
    group.findOne(
      (n) => typeof n.name === 'function' && n.name() === 'element background',
    ) ||
    null
  );
}
